<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/qtbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'统战管理系统'"></detailBread>
        <div class="container">
            <div class="page-title">
                统战管理系统
            </div>
            <div class="page-content" style="text-align:left;width:1000px;margin:0 auto;">
                <p>高校历来是党的统战工作的重要阵地，统战工作涉及面广，综合性强，具有统战对象多、层次高、影响大、参政议政能力强等特点。</p>
                <p>作为统战工作重要组成部分的高校统战工作是不可或缺的，也是实现高等教育协调发展、构建和谐校园的重要条件。</p>
                <p>在对高校统战工作的重要性上有了充分的认知和调研基础上，我们利用信息化手段，设计出高校统战管理系统，力求让高校统战管理工作更加高效、有序地开展。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">一、覆盖所有统战对象</p>
                <p>昂克高校统战系统覆盖了所有个人（各党派成员、党派秘书、党派领导）、所有集体（各党派），以及除此之外的无党派人士，不同角色赋予不同权限，实现人人参与。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">二、利用信息化手段收集和统计信息</p>
                <p>个人、各党派对各自的信息进行完善，系统自动统计归档，实现快速查询，结合数字和图表的形式，更直观地进行信息的展现。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">三、团结协作，“共同奋战”</p>
                <p>统战部门统一领导下人人参与的模式。不同角色的人员各司其职，紧紧围绕统战部门，减轻统战部门工作负担，提供统战工作效率。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">四、融入统一平台，实现信息共享</p>
                <p>与统一平台对接，告别“信息孤岛”，实现信息共享。紧跟信息化校园建设的步伐，告别各部门之间不停奔走的工作状态。</p>
                <p style=" font-size: 18px; font-weight: bold; margin: 20px 0;">五、贯彻统战工作方针，体现统战工作成果</p>
                <p>通过“提案议案”、“学习资料库”、“获奖信息”、“工作总结”等功能来具体体现。发现优秀、树立典型，更具体地体现统战工作的成果。</p>

            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '统战管理系统', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '统战管理系统'
        },
        {
            name: 'description',
            content: '统战管理系统'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'3',
        }
    },
    methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
.page-content p {
    text-indent: 32px;
    font-size: 16px;
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/old/tzglxt.vue